import React from 'react'
import ServiceForm from '../components/ServiceForm';

const Contact = () => {
  return (
    <ServiceForm />
  )
}

export default Contact